<template>
    <div class="section">
      <!--========== PROMO BLOCK ==========-->
      <div class="s-promo-block-v3 g-bg-position--center" :class="{'g-fullheight--xs': block.options.fullHeight}" :style="sectionStyle">
        <div class="container" :class="{'g-ver-center--xs': block.options.fullHeight, 'g-text-left--xs': block.options.align == 'left', 'g-text-right--xs': block.options.align == 'right'}">
          <div class="g-margin-t-30--xs g-margin-t-0--sm g-margin-b-30--xs g-margin-b-70--md">
            <h1 class="g-font-size-35--xs g-font-size-45--sm g-font-size-50--lg" v-html="block.options.title.text" :style="titleStyle" ref="title"></h1>
          </div>
          <div class="row">
            <div class="col-sm-8 col-sm-push-4 g-margin-b-50--xs g-margin-b-0--md">
              <div class="s-promo-block-v3__divider g-display-none--xs g-display-block--md"></div>
              <div class="row">
                <div class="col-sm-6 g-margin-b-30--xs g-margin-b-0--md">
                  <div class="animated fadeInLeft">
                    <p class="g-font-size-18--xs" v-html="block.options.subtitle.text" :style="subtitleStyle" ref="subtitle"></p>
                  </div>
                </div>
                <div class="col-sm-5 col-sm-offset-1">
                  <div class="clearfix">
                    <div class="pull-left">
                      <div class="animated fadeInLeft">
                        <span class="s-promo-block-v3__date g-font-size-100--xs g-font-size-135--lg g-font-weight--300" v-html="block.options.date.dayText" :style="dateDayStyle" ref="dateDay"></span>
                      </div>
                    </div>
                    <div class="animated fadeInLeft inline-block">
                      <span class="s-promo-block-v3__month g-font-size-18--xs g-font-size-22--lg g-font-weight--300" v-html="block.options.date.monthText" :style="dateMonthStyle" ref="dateMonth"></span>
                      <br>
                      <span class="s-promo-block-v3__year g-font-size-18--xs g-font-size-22--lg g-font-weight--300" v-html="block.options.date.yearText" :style="dateYearStyle" ref="dateYear"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4 col-sm-pull-8">
              <div class="animated fadeInLeft">
                <a :class="`js__popup__youtube-${ block.blockID }`" :href="block.options.vidButton.href" :title="block.options.vidButton.title">
                  <i class="s-icon s-icon--lg s-icon--white-bg g-radius--circle ti-control-play"></i>
                  <span class="text-uppercase g-font-size-13--xs g-color--white g-padding-x-15--xs" v-html="block.options.vidButton.text"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--========== END PROMO BLOCK ==========-->

      <!-- Scroll to next -->
      <a v-if="block.options.scrollNext && block.options.scrollNext.enabled" href="javascript:void(0);" class="js-scroll-to-next s-scroll-to-section-v1--bc g-margin-b-15--xs">
          <span class="g-font-size-18--xs g-color--white ti-angle-double-down"></span>
          <p class="text-uppercase g-color--white g-letter-spacing--3 g-margin-b-0--xs" v-html="block.options.scrollNext.text"></p>
      </a>

      <block-settings :block="block" :order="order" @moveBlockUp="moveBlockUp" @moveBlockDown="moveBlockDown" @deleteBlock="deleteBlock" @afterUpload="afterUpload" @afterSettingsClose="afterSettingsClose"></block-settings>

    </div>
</template>

<script>
import { BlocksMixin } from "../util/mixins";

export default {
  mixins: [BlocksMixin],
  mounted() {
    this.editables = [
      this.$refs.title,
      this.$refs.subtitle,
      this.$refs.dateDay,
      this.$refs.dateMonth,
      this.$refs.dateYear
    ];
  },
  computed: {
    sectionStyle() {
      return {
        backgroundImage: this.block.options.bg.url
          ? `url( ${this.block.options.bg.url} )`
          : "",
        backgroundColor: this.block.options.bg.color
          ? this.block.options.bg.color
          : "",
        padding: this.block.options.fullHeight ? "0" : "200px 0"
      };
    },
    titleStyle() {
      return {
        color: this.block.options.title.color
      };
    },
    subtitleStyle() {
      return {
        color: this.block.options.subtitle.color
      };
    },
    dateDayStyle() {
      return {
        color: this.block.options.date.dayColor
      };
    },
    dateMonthStyle() {
      return {
        color: this.block.options.date.monthColor
      };
    },
    dateYearStyle() {
      return {
        color: this.block.options.date.yearColor
      };
    }
  },
  methods: {
    deleteBlock() {
      if (this.editor1) {
        this.editor1.destroy();
      }
      this.$emit("deleteBlock");
    },
    afterUpload() {},
    afterSettingsClose() {},
    appendCustomScript() {
      this.addScriptInline(`
        $(document).ready(function() {
          $('.js__popup__youtube-${this.block.blockID}').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true
          });

          $('.js-scroll-to-next').on('click', function() {
            var page = $("html, body");
            page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                page.stop();
            });
            var target = $(this).parent();
            if (target.length) {
              page.animate({
                scrollTop: target.offset().top + target.height()
              }, 600, function(){
                  page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
              });
            }
            return false;
          });

        });
      `);
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/blocks/BlockHeader2.vue